/**
 * Variante de la coquille selon la largeur (U6b vague 9, planches *Telephone et *Tablette) :
 * - téléphone (< 768 px, planche à 390) : barre haute compacte, tiroir plein écran ;
 * - tablette (768 à 1023 px, planche à 768) : rail des groupes + panneau modal ;
 * - bureau (≥ 1024 px) : barre latérale dépliée.
 * Mêmes seuils que les préfixes Tailwind `md` et `lg`, pour que le CSS et le JS s'accordent.
 */
import { useEffect, useState } from 'react'

export type VarianteCoquille = 'telephone' | 'tablette' | 'bureau'

export const SEUIL_TABLETTE = 768
export const SEUIL_BUREAU = 1024

export function varianteDeLargeur(largeur: number): VarianteCoquille {
  if (largeur < SEUIL_TABLETTE) return 'telephone'
  if (largeur < SEUIL_BUREAU) return 'tablette'
  return 'bureau'
}

function largeurCourante(): number {
  return typeof window === 'undefined' ? SEUIL_BUREAU : window.innerWidth
}

export function useVarianteCoquille(): VarianteCoquille {
  const [variante, setVariante] = useState<VarianteCoquille>(() => varianteDeLargeur(largeurCourante()))
  useEffect(() => {
    const maj = (): void => setVariante(varianteDeLargeur(largeurCourante()))
    const requetes = [`(max-width: ${SEUIL_TABLETTE - 1}px)`, `(max-width: ${SEUIL_BUREAU - 1}px)`]
      .map((q) => window.matchMedia?.(q))
      .filter((m): m is MediaQueryList => Boolean(m))
    requetes.forEach((m) => m.addEventListener?.('change', maj))
    window.addEventListener('resize', maj)
    maj()
    return () => {
      requetes.forEach((m) => m.removeEventListener?.('change', maj))
      window.removeEventListener('resize', maj)
    }
  }, [])
  return variante
}
